export default __webpack_public_path__ + "align-justify.png";